var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseMenu = function SvgCloseMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(.33)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#FFF",
    fillOpacity: 0.4,
    opacity: 0.1,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M23 8.611 21.389 7 15 13.389 8.611 7 7 8.611 13.389 15 7 21.389 8.611 23 15 16.611 21.389 23 23 21.389 16.611 15z"
  }))));
};
export default SvgCloseMenu;